import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const JoinTournament = () => {
  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTournaments();
  }, []);

  const fetchTournaments = async () => {
    try {
      const response = await fetch('https://app.bitsport.gg/api/tournaments');
      if (!response.ok) {
        throw new Error('Failed to fetch tournaments');
      }
      const data = await response.json();
      setTournaments(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleJoinTournament = async (tournamentId) => {
    try {
      const response = await fetch(`https://app.bitsport.gg/api/tournaments/${tournamentId}/join`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to join tournament');
      }

      // Refresh tournaments list
      fetchTournaments();
    } catch (error) {
      console.error('Error joining tournament:', error);
    }
  };

  if (loading) {
    return (
      <div className="p-6 text-white text-center">
        <div className="text-xl">Loading tournaments...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6 text-white text-center">
        <div className="text-xl text-red-500">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="p-6 text-white">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold">Available Tournaments</h1>
        <Link
          to="/create-tournament"
          className="px-6 py-3 bg-purple-600 rounded-xl font-semibold hover:bg-purple-700"
        >
          Create Tournament
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {tournaments.map((tournament) => (
          <div key={tournament._id} className="bg-gray-900 rounded-xl overflow-hidden">
            <img
              src={tournament.thumbnail}
              alt={tournament.title}
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h2 className="text-xl font-bold mb-2">{tournament.title}</h2>
              <div className="space-y-2 text-gray-300 text-sm mb-4">
                <p>Game: {tournament.game}</p>
                <p>Prize Pool: {tournament.prize}</p>
                <p>Date: {new Date(tournament.date).toLocaleDateString()}</p>
                <p>Participants: {tournament.participants.length}/{tournament.maxParticipants}</p>
                <p className={`${
                  tournament.status === 'Registration Open'
                    ? 'text-green-400'
                    : 'text-red-400'
                }`}>
                  Status: {tournament.status}
                </p>
              </div>
              <div className="flex gap-4">
                <Link
                  to={`/tournaments/${tournament._id}`}
                  className="flex-1 px-4 py-2 bg-gray-800 rounded-lg text-center hover:bg-gray-700"
                >
                  View Details
                </Link>
                {tournament.status === 'Registration Open' && (
                  <button
                    onClick={() => handleJoinTournament(tournament._id)}
                    className="flex-1 px-4 py-2 bg-purple-600 rounded-lg hover:bg-purple-700"
                    disabled={tournament.participants.length >= tournament.maxParticipants}
                  >
                    {tournament.participants.length >= tournament.maxParticipants
                      ? 'Full'
                      : 'Join Now'}
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {tournaments.length === 0 && (
        <div className="text-center text-gray-400 mt-8">
          <p className="text-xl">No tournaments available at the moment.</p>
          <p className="mt-2">Be the first to create one!</p>
        </div>
      )}
    </div>
  );
};

export default JoinTournament;